import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Widget } from '@digital/ui';
import { hasPermission } from '@app/helpers/permissions';
import { concluir } from '@app/api/contrato/correspondencia';

export interface propsModalConcluir {
  id: string;
  justificativa: string;
  concluido: false;
  onUpdate: any;
}

const ModalConcluir = (props: propsModalConcluir) => {
  const { id, justificativa, concluido, onUpdate } = props;
  const [exibirModal, setExibirModal] = useState(false);

  const handleSubmit = values => {
    concluir({ id, justificativa: values.justificativa }).then(data => {
      if (data) {
        setExibirModal(false);
        onUpdate();
      }
    });
  };

  return (
    <>
      <Tooltip title="Concluir">
        <Button
          onClick={() => {
            setExibirModal(true);
          }}
          icon="ui-approval"
          name="btnConcluir"
        />
      </Tooltip>
      <Modal
        title="Concluir"
        // className="chat-modal"
        width="860px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formModal"
          onSubmit={handleSubmit}
          actions={
            <>
              <Button
                type="link"
                onClick={() => {
                  setExibirModal(false);
                }}>
                Fechar
              </Button>
              {concluido ? (
                <></>
              ) : (
                <FormSubmitButton noIcon={true} type="primary" disabled={false}>
                  <FormatText id="ui.commons.save" uppercase />
                </FormSubmitButton>
              )}
            </>
          }>
          <Widget>
            {concluido ? (
              <FormTextArea
                value={justificativa}
                name="justificativa"
                label="Justificativa"
                span={12}
                rows={4}
                maxLength={2000}
                disabled
              />
            ) : (
              <FormTextArea name="justificativa" label="Justificativa" span={12} rows={4} maxLength={2000} />
            )}
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};
export default ModalConcluir;
